const harmonizedAccount = {
  Password: "Password",
  e2eAttributes: {
    password: "password",
  },
  PlaceHolderConfirmPassword: "Confirm new password",
  PasswordsDontMatch: "The passwords you entered do not match.",
  PasswordsMatch: "Passwords match",
  LengthValidation: "Must be at least 8 characters long",
  LengthConfirmation: "Password is 8+ characters long",
  nextStep: "Next step",
  Security: {
    title: "Choose your new password",
    content:
      "Use the same password for Emerson Ecologics and Fullscript when you log in as <strong>{{email}}</strong>.",
  },
} as const;

export { harmonizedAccount };
